import orderConfig from 'emun.order/order.config';
import basicController from "servicestack/basic.controller.properties";
import AutoQuery from "servicestack/auto-query/auto-query";
import "emun.vendor/picker/vendorgroup-picker-table.htm";
//import customerConfig from "emun.customer/customer.config";
import VendorParser from "emun.vendor/parser/vendor-parser";
//import ApplyTagsPrompt from "emun.customer/picker/apply-retailer-tags-prompt";

//export const filters = customerConfig.filters;

export const views = {
	list: "table",
	//  cards: "th-large"
};

export default class VendorGroupPickerController {
	constructor(options) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.selected = {};
		Object.assign($ctrl, options);
		$ctrl.setVendorGroups();
		$ctrl.query = new AutoQuery($ctrl.getAutoQueryOptions());
		$ctrl.bus = $ctrl.query.bus;
		//$ctrl.viewSelectionsChanged(); //load()
	}

	templateUrl = () => `vendorgroup-picker-${this.query.view}.htm`;

	selectAll() {
		const $ctrl = this;
		$ctrl.query.results.forEach(p => ($ctrl.selected[p.groupName] = true));
		this.setVendorGroups();
	}
	clearAll() {
		this.selected = {};
		this.setVendorGroups();
	}
	canClear() {
		return Object.keys(this.selected).length;
	}

	isSelected(vendorgroup) {
		return !!this.selected[vendorgroup.groupName];
	}

	setVendorGroups() {
		this.vendorGroups = Object.keys(this.selected || {});
	}

	selectionsLabel() {
		const { vendorGroups: keys = [] } = this;
		if (keys.length > 4)
			return `Selected: ${keys.slice(0, 4).join(", ")} and ${keys.length -
				4} more...`;
		if (keys.length > 0) return `Selected: ${keys.slice(0, 4).join(", ")}`;
		return "No selections";
	}

	hasSelections = () => Object.keys(this.selected).length > 0;

	viewSelectionsChanged() {
		const $ctrl = this;
		const idIn = $ctrl.viewSelections
			? Object.keys($ctrl.selected || {}).join(",")
			: null;
		$ctrl.query.clearRefinements(false);
		$ctrl.query.filter("IdIn", idIn);
	}

	toggle(vendorgroup) {
		const $ctrl = this;
		console.log("toggle", vendorgroup.groupname, $ctrl.selected, vendorgroup);

		if ($ctrl.single) {
			$ctrl.$close(vendorgroup);
		} else if (vendorgroup.id in $ctrl.selected) {
			delete $ctrl.selected[vendorgroup.groupName];
			$ctrl.onVendorGroupUnSelected &&
				$ctrl.onVendorGroupUnSelected({ $vendorgroup: vendorgroup, ...$ctrl });
		} else {
			$ctrl.selected[vendorgroup.groupName] = true;
			$ctrl.onVendorGroupSelected &&
				$ctrl.onVendorGroupSelected({ $vendorgroup: vendorgroup, ...$ctrl });
		}
		this.setVendorGroups();
	}
	select(vendorgroup) {
		const $ctrl = this;
		$ctrl.$close([vendorgroup]);
	}

	$onDestroy() {
		this.query.dispose();
	}

	// parseVendors() {
	// 	const $ctrl = this;
	// 	VendorParser({}).then(vendorIds => {
	// 		$ctrl.selected = {};
	// 		vendorIds.forEach(vendorId => {
	// 			$ctrl.toggle({ id: vendorId });
	// 		});
	// 		$ctrl.viewSelections = true;
	// 		$ctrl.viewSelectionsChanged();
	// 	});
	// }

	getAutoQueryOptions() {
		const $ctrl = this;
		return {
			url: "QueryVendorGroupList.json",
			pageSize: $ctrl.$pageConfig.is("gt-sm") ? 12 : 6,
			views,
			criteria: $ctrl.criteria,
			view: "table",
//			filters,
			// sortOptions: {
			// 	"GroupName": "Name",
			// 	"-GroupName": "Name"
			// },
			hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
			//orderBy: "GroupName",
			autoLoad: true,
			append: false
		};
	}
}


